/*
 * File: index.tsx
 * Desc: 表单日期组件
 * File Created: 2019-10-15 09:49:12
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React from 'react';
import { Form, DatePicker } from 'antd';
import { FormBaseProps } from '../form-input';
import { FormProps } from 'antd/lib/form';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import moment from 'moment';
import locale from 'antd/lib/date-picker/locale/zh_CN';
import 'moment/locale/zh-cn';

interface FormDateProps extends FormBaseProps, Omit<FormProps, 'onChange'> {
    /** 是否是范围日期选择 */
    isRange?: boolean;
    /** 日期转换格式 */
    format?: string;
    /** 挂载的节点 */
    mountContainer?: string;
    /** 是否显示时间 */
    showTime?: boolean;
    /** 日期框Date组件的props */
    dateProps?: any;
    placeholder?: string;
    /** 不可选择日期和时间 */
    disabledDate?: () => any;
    disabledTime?: () => any;
    onChange?: (date: moment.Moment | null, dateString: string, setFieldsValue: Function) => void;
}

const FormDate = (props: FormDateProps) => {
    const {
        label,
        labelCol,
        wrapperCol,
        isRange,
        field,
        initialValue,
        required,
        mountContainer,
        validator,
        onChange,
        dateProps,
        placeholder,
        format,
        showTime,
    } = props;
    const { getFieldDecorator, getFieldValue, setFieldsValue } = props.form as WrappedFormUtils;
    const customPlaceholder = placeholder ? placeholder : `请选择${label}`;
    return (
        <Form.Item
            {...{
                label,
                labelCol,
                wrapperCol,
            }}
            className={props.className}
        >
            {getFieldDecorator(field, {
                initialValue,
                rules: [
                    { required, message: `请选择${label}` },
                    {
                        validator: (rule, value, callback) =>
                            validator ? validator(rule, value, callback) : callback(),
                    },
                ],
                normalize: (value: any) => {
                    // 转换moment类型给组件
                    if (value && value.length > 0) {
                        if (isRange && !moment.isMoment(value[0]))
                            return [moment(value[0]), moment(value[1])];
                        if (!isRange && !moment.isMoment(value)) return moment(value);
                    }
                    return value;
                },
            })(
                props.readOnly ? (
                    props.render ? (
                        props.render(getFieldValue(field))
                    ) : (
                        <span>
                            {moment.isMoment(getFieldValue(field))
                                ? getFieldValue(field).format('YYYY-MM-DD')
                                : getFieldValue(field)}
                        </span>
                    )
                ) : isRange ? (
                    <DatePicker.RangePicker
                        {...({
                            ...(mountContainer && {
                                getPopupContainer: () => document.getElementById(mountContainer)!,
                            }),
                        } as any)}
                        onChange={(date: any, dateString: any) =>
                            onChange && onChange(date, dateString, setFieldsValue)
                        }
                        {...dateProps}
                        locale={locale}
                    />
                ) : (
                    <DatePicker
                        style={{ width: '100%' }}
                        showTime={showTime}
                        {...dateProps}
                        format={format}
                        placeholder={customPlaceholder}
                        onChange={(date, dateString) =>
                            onChange && onChange(date, dateString, setFieldsValue)
                        }
                        locale={locale}
                        {...(mountContainer && {
                            getPopupContainer: () => document.getElementById(mountContainer)!,
                        })}
                    />
                )
            )}
        </Form.Item>
    );
};

export default FormDate;
